import { render, staticRenderFns } from "./TestFieldMapper.vue?vue&type=template&id=536652c9&scoped=true"
import script from "./TestFieldMapper.vue?vue&type=script&lang=js"
export * from "./TestFieldMapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536652c9",
  null
  
)

export default component.exports